<script>
  // Extensions
  import View from '@/views/View'

  // Mixins
  import LoadSections from '@/mixins/load-sections'

  export default {
    name: 'Insights',

    metaInfo: { title: 'Insights' },

    extends: View,

    mixins: [
      LoadSections([
        'hero-alt',
        'insights',
      ]),
    ],

    props: {
      id: {
        type: String,
        default: 'about',
      },
    },
  }
</script>
